module.exports = "/images/brochure.svg?e5e1fe2bdbc5468cebe195e0d2e5e093";